module.exports = __webpack_public_path__ + "img/hic-diabetes-mellitus-male.80db7ec9.png";